import React, { Fragment } from 'react';

import { formatCurrency } from 'utils/CurrencyUtils';

import { groupToppingsByCategory } from '../../domain';
import type { ScheduledOrderDetailProduct } from '../../domain';

import makeClasses from './SOProductDetail.style';

interface Props {
  products: ScheduledOrderDetailProduct[];
}

export function SOProductDetail({ products }: Props) {
  const classes = makeClasses();

  return (
    <ul className={classes.productList}>
      {products.map((product, index) => {
        const toppingGroups = groupToppingsByCategory(product.toppings);
        const isLast = index === products.length - 1;

        return (
          <Fragment key={product.id}>
            <li className={classes.productItem}>
              <div className={classes.productHeader}>
                <div className={classes.productNameRow}>
                  <span
                    className={classes.productUnits}
                  >{`${product.units}x`}</span>
                  <span className={classes.productName}>{product.name}</span>
                </div>
                <span className={classes.productPrice}>
                  {formatCurrency(product.totalPrice)}
                </span>
              </div>

              {product.description ? (
                <p className={classes.productDescription}>
                  {product.description}
                </p>
              ) : null}

              {toppingGroups.length > 0 && (
                <div className={classes.toppings}>
                  {toppingGroups.map(group => (
                    <Fragment key={group.categoryId}>
                      <p className={classes.toppingCategory}>
                        {group.categoryDescription}
                      </p>
                      {group.toppings.map(topping => (
                        <div key={topping.id} className={classes.toppingDetail}>
                          <div className={classes.toppingRow}>
                            <p className={classes.toppingDescription}>
                              {`${topping.units}x ${topping.description}`}
                            </p>
                            <p className={classes.toppingPrice}>
                              {formatCurrency(topping.price)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </Fragment>
                  ))}
                </div>
              )}
            </li>
            {!isLast && <li className={classes.divider} aria-hidden='true' />}
          </Fragment>
        );
      })}
    </ul>
  );
}
